<template>
  <div id="login">
    <body class="login-page err-500">
        <div class="container">
        <loading :active.sync="isLoading" 
                  :can-cancel="true" 
                  :is-full-page="fullPage"></loading>
            <div class="login-container">
                <div class="row">
                    <div class="col-lg-4 col-md-5 col-sm-9 lfh">
                        <div class="card login-box">
                            <div class="card-body">
                                <h5 class="card-title">Reset Password</h5>
                                <form @keyup.enter="reset(e)">
                                <p style="color:red;text-align:center">{{ errorMessage ? errorMessage : ''  }}</p>
                                 <p v-if="errors.length">
                                  <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
                                  </p>
                                    <div class="form-group">
                                        <input type="password" ref="password" name="password" v-model="input.password" placeholder="Password"  class="form-control" id="password">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" ref="cnfpassword" name="cnfpassword" v-model="input.cnfpassword" placeholder="Confirm Password"  class="form-control" id="cnfpassword">
                                    </div>
                                    <button type="button" class="btn btn-primary m-l-xxs float-right" v-on:click="reset(e)">Password Reset</button>
                                    </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>
  </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'Resetpassword',
    components: {
       Loading
     },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        errors: [],
        errorMessage: '',
        input: {
          password: '',
          cnfpassword: ''
        }
      }
    },
    methods: {
      reset (e) {
        this.errors = []
        var pass = this.input.password
        var jwttoken = localStorage.getItem('jwt')
        if (this.input.password === '') {
          this.errors.push('Password is Required')
          this.$refs.password.focus()
        } else if (pass.length < 6) {
          this.errors.push('Password must be 6 characters long')
          this.$refs.password.focus()
        } else if (this.input.cnfpassword === '') {
          this.errors.push('Confirm Password is Required')
          this.$refs.cnfpassword.focus()
        } else if (this.input.password !== this.input.cnfpassword) {
          this.errors.push('Password & Confirm Password does not matched')
          this.$refs.cnfpassword.focus()
        } else {
          var password = this.input.password
          var cnfpassword = this.input.cnfpassword
          var token = this.$route.query.token
          this.isLoading = true
          axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/resetPassword',
            {
              password: password,
              confirm_password: cnfpassword,
              token: token
            }, {
              headers: {
                'x-access-token': jwttoken
              }})
            .then(response => {
               this.errorMessage = response.data.message
               this.input.password = '' 
               this.input.cnfpassword = ''
               this.isLoading = false
               window.open('/login');
               
             })
             .catch((error) => {
                 this.errorMessage = error.response.data.errors
                 this.input.password = '' 
                 this.input.cnfpassword = ''
                 this.isLoading = false
              
             })
        }
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/resetPassword.vue